module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av167-9ad3a59a988652a506cbd251175301b8.jpg";